export * from './foundation-type-3.component';